module.exports = __webpack_public_path__ + "media/components/Builder/Library/Images/Tools/AddCell-7bc5ece0350003f6ef3c1b4740a61148.svg";